<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>
		<main-content
			v-if="!page.introblock"
			:title="page.title || page.header"
			:content="page.content"
			:intro-image="{
				image: page.introductionImage,
				imageWebp: page.introductionImageWebp,
			}"
		/>

		<intro-block v-if="page.introblock" :item="page.introblock" />

		<frequently-asked-questions :items="faqs" />

		<contentblocks :items="page.contentblocks" />
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { locale } = useI18n();

await fetchPage();

const { data: faqs } = await useWebsiteFetch('frequentlyAskedQuestions', {
	query: { language: locale.value },
	key: `${locale.value}/frequentlyAskedQuestions`,
});
</script>

<style lang="scss" scoped>
:deep(h1) {
	color: var(--footer-background-color);
}
</style>
